import React, { useState, useContext } from "react";
import Text from "antd/lib/typography/Text";
import { Col, Row, Timeline } from "antd";
import { CheckCircleOutlined, LinkOutlined } from "@ant-design/icons";

import "./index.css";
import Sidebar from "../../../components/Sidebar";
import { DateFormat } from "../../../helpers";
import Badge from "../../../components/Badge";
import OrderSidebar from "../../Orders/OrderSidebar";
import { StoreContext } from "../../../context";

// Payments -> payment_id,payment_type,payment_status,order_id,user_id,first_name,last_name,email,mobile,created_at,provider,amount,reference_id,razorpay_ref_id,PaymentLogs
export default function PaymentSidebar({
  visible = false,
  data = {},
  onClose,
  refBack = false,
}) {
  const { storeId } = useContext(StoreContext);
  const [orderSidebar, setOrderSidebar] = useState(false);

  return (
    <>
      <Sidebar
        key="payment-sidebar"
        title="Payment Details"
        visible={visible}
        onClose={onClose}
        // footer={
        // <div style={{ textAlign: "right" }}>
        //   <Button onClick={() => {}} type="primary">
        //     Update Payment
        //   </Button>
        // </div>
        // }
      >
        <Row>
          {!storeId && (
            <Col className="lblc" xs={24} md={12}>
              <Text style={{ fontSize: 11 }} type="secondary">
                Store Name
              </Text>
              <br />
              <Text>{data.store_name}</Text>
            </Col>
          )}
          <Col className="lblc" xs={24} md={12}>
            <Text style={{ fontSize: 11 }} type="secondary">
              Payment Id
            </Text>
            <br />
            <Text>{data.payment_id}</Text>
          </Col>
          {/* <Col className='lblc' xs={24} md={12}>
            <Text style={{ fontSize: 11 }} type='secondary'>
              Reference Id
            </Text>
            <br />
            <Text>
              {data.reference_id}
            </Text>
          </Col> */}
          <Col className="lblc" xs={24} md={12}>
            <Text style={{ fontSize: 11 }} type="secondary">
              Order Id
            </Text>
            <br />
            <Text>
              <a
                href="#"
                onClick={() => {
                  if (refBack) {
                    onClose();
                  } else {
                    setOrderSidebar(true);
                  }
                }}
                title="View Order"
              >
                {data.order_id} <LinkOutlined />
              </a>
            </Text>
          </Col>
          <Col className="lblc" xs={24} md={12}>
            <Text style={{ fontSize: 11 }} type="secondary">
              Customer Name
            </Text>
            <br />
            <Text>{data.name}</Text>
          </Col>
          <Col className="lblc" xs={24} md={12}>
            <Text style={{ fontSize: 11 }} type="secondary">
              Reference Id
            </Text>
            <br />
            <Text>{data.razorpay_ref_id ? data.razorpay_ref_id : "-"}</Text>
          </Col>
          <Col className="lblc" xs={24} md={12}>
            <Text style={{ fontSize: 11 }} type="secondary">
              Customer Mobile
            </Text>
            <br />
            <Text>{data.mobile}</Text>
          </Col>
          <Col className="lblc" xs={24} md={12}>
            <Text style={{ fontSize: 11 }} type="secondary">
              Customer Email
            </Text>
            <br />
            <Text>{data.email}</Text>
          </Col>
          <Col className="lblc" xs={24} md={12}>
            <Text style={{ fontSize: 11 }} type="secondary">
              Amount
            </Text>
            <br />
            <Text>{data.amount}</Text>
          </Col>
          <Col className="lblc" xs={24} md={12}>
            <Text style={{ fontSize: 11 }} type="secondary">
              Date
            </Text>
            <br />
            <Text>{DateFormat(data.created_at)}</Text>
          </Col>
          <Col className="lblc" xs={24} md={12}>
            <Text style={{ fontSize: 11 }} type="secondary">
              Status
            </Text>
            <br />
            <Badge paymentStatus={data.payment_status}></Badge>
          </Col>
          <Col className="lblc" xs={24} md={12}>
            <Text style={{ fontSize: 11 }} type="secondary">
              Method
            </Text>
            <br />
            <Text style={{ textTransform: "capitalize" }}>
              {data.payment_type ? data.payment_type : "-"}
            </Text>
          </Col>
          {/* Delivery Information - Only for COD */}
          {data.payment_type === "COD" && (
            <>
              <Col className="lblc" xs={24} md={12}>
                <Text style={{ fontSize: 11 }} type="secondary">
                  Delivery Boy ID
                </Text>
                <br />
                <Text>
                  {data.meta && Object.keys(data.meta).length > 0 && data.meta.staff_id
                    ? data.meta.staff_id
                    : "-"}
                </Text>
              </Col>
              <Col className="lblc" xs={24} md={12}>
                <Text style={{ fontSize: 11 }} type="secondary">
                  Delivery Boy Name
                </Text>
                <br />
                <Text>
                  {data.meta && Object.keys(data.meta).length > 0 && data.meta.staff_name
                    ? data.meta.staff_name
                    : "-"}
                </Text>
              </Col>
              <Col className="lblc" xs={24} md={12}>
                <Text style={{ fontSize: 11 }} type="secondary">
                  Delivery Boy Mobile
                </Text>
                <br />
                <Text>
                  {data.meta && Object.keys(data.meta).length > 0 && data.meta.staff_mobile
                    ? data.meta.staff_mobile
                    : "-"}
                </Text>
              </Col>
            </>
          )}
          <Col xs={24}>
            <Text strong>Payment Trails</Text>
            <Timeline
              style={{ marginTop: 15, marginLeft: 5, borderColor: "red" }}
              mode="left"
            >
              {data.PaymentLogs &&
                data.PaymentLogs.map((log, index) => {
                  let text = "";
                  let color = "#096dd9";
                  if (log.status === "created") {
                    text = "Initiated";
                  } else if (log.status === "captured") {
                    text = "received";
                    color = "";
                  } else if (log.status === "failed") {
                    color = "red";
                  } else if (log.status === "refunded") {
                    color = "orange";
                  }
                  return (
                    <Timeline.Item
                      key={index}
                      dot={
                        <CheckCircleOutlined
                          style={{ fontSize: 18, color: color }}
                        />
                      }
                    >
                      <Text strong style={{ textTransform: "capitalize" }}>
                        {text ? text : log.status}
                      </Text>
                      <br />
                      <Text style={{ fontSize: 12 }}>
                        {DateFormat(log.created_at)}
                      </Text>
                      <br />
                      {log.reason && (
                        <>
                          <Text
                            ellipsis={{ tooltip: log.reason }}
                            style={{ fontSize: 12, width: 100 }}
                          >
                            {log.reason}
                          </Text>
                        </>
                      )}
                    </Timeline.Item>
                  );
                })}
              {/* {data.PaymentLogs &&
                data.PaymentLogs.length > 0 &&
                !data.PaymentLogs.some((log) => log.status === "captured") && (
                  <Timeline.Item
                  dot={
                    <ExclamationCircleOutlined
                      style={{ fontSize: 18, color: "#d4b106" }}
                    />
                  }
                  >
                    <Text strong>Received</Text>
                  </Timeline.Item>
                )} */}
            </Timeline>
            {/* <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                marginTop: 15,
              }}
            >
              <div className='cnt-nav'>
                <div className='lst-itms'>
                  <ul className='lst'>
                    {data.PaymentLogs &&
                      data.PaymentLogs.map((log, index) => {
                        return (
                          <li
                            key={index}
                            className={
                              data.PaymentLogs.length > index + 1
                                ? 'itm compltd'
                                : 'itm activ'
                            }
                          >
                            <div>
                              <Text
                                strong
                                style={{ textTransform: 'capitalize' }}
                              >
                                {log.status}
                              </Text>
                              <br />
                              <>
                                <Text style={{ fontSize: 12 }}>
                                  {DateFormat(log.created_at)}
                                </Text>
                                <br />
                                <Text style={{ fontSize: 12 }}>
                                  {log.reason}
                                </Text>
                              </>
                            </div>
                          </li>
                        )
                      })}
                    {!data.PaymentLogs && (
                      <li className='itm'>
                        <Text strong>Issued</Text>
                      </li>
                    )}
                    {data.PaymentLogs &&
                    data.PaymentLogs.find(
                      (log) => log.status === 'captured'
                    ) ? null : (
                      <li className='itm'>
                        <Text strong>Received</Text>
                      </li>
                    )}
                  </ul>
                </div>
              </div>
            </div> */}
          </Col>
        </Row>
      </Sidebar>
      {orderSidebar && (
        <OrderSidebar
          visible={orderSidebar}
          onClose={() => setOrderSidebar(false)}
          order_id={data.order_id}
          refBack={true}
        />
      )}
    </>
  );
}
